// const NODE_ENV = process.env.NODE_ENV;

// if ( !NODE_ENV || NODE_ENV == "development" ) {
  module.exports = {
    email_body: `Her kommer din personlige oppropslink, der du må registrere opprop for dine øvelser.
Oppropsfrist er 2 timer før øvelsesstart, det er mulig å registrere opprop fra kl 19 dagen før øvelsen.
Det er elektronisk opprop for alle øvelser.

Dersom du ikke stiller er det fint om du krysser av og deretter fjerner avkrysningen

Dersom det skulle oppstå en skade etter oppropsfristen har utløpt, kan du kontakte oss i sekretariatet
`,
  };
// } else {
//   module.exports = {
//   };
// }
